const SearchParamChangedEvent = require('@adobe-fonts/site/events/SearchParamChangedEvent.js');
const SearchSubmitEvent = require('@adobe-fonts/site/events/SearchSubmitEvent.js');
var CUSTOM_SMALL_BREAKPOINT_WIDTH = 500;
var SPECTRUM_SMALL_BREAKPOINT_WIDTH = 768;

/**
 * @ngInject
 */
function MarketplaceHomeController($document, $scope, $window, DataService, FamilyAutocompleteSearchService) {
  this.$document = $document;
  this.$window = $window;
  this.DataService = DataService;
  this.FamilyAutocompleteSearchService = FamilyAutocompleteSearchService;
  this._preloadData();

  // Needed for getSmallScreenClass
  $window.addEventListener('resize', function() {
    $scope.$apply();
  });

  $window.addEventListener(SearchSubmitEvent.EVENT_NAME, function(event) {
    const { searchValue } = event.detail;
    if (searchValue) {
      window.location.href = `/search?query=${encodeURIComponent(searchValue)}`;
    }
  });
}

MarketplaceHomeController.prototype._webComponents_initSearchBar = function() {
  var self = this;

  // Initialize hero section search bar
  const heroSearchBar = document.querySelector('#hero-searchbar');
  if (heroSearchBar) {
    heroSearchBar.addEventListener(SearchParamChangedEvent.EVENT_NAME, function(event) {
      self.FamilyAutocompleteSearchService.get(event.detail.searchParam).then(function(response) {
        heroSearchBar.results = response.data;
      });
    });
  }
};

/**
 * xs-6 is too small for mobile screen sizes, but xs-12 is too large for the 500-768px range,
 * so this function toggles them.
 *
 * @returns {String}
 */
MarketplaceHomeController.prototype.getSmallScreenClass = function() {
  if (this.$window.innerWidth < CUSTOM_SMALL_BREAKPOINT_WIDTH) {
    return 'spectrum-grid-col-xs-12';
  }
  if (this.$window.innerWidth < SPECTRUM_SMALL_BREAKPOINT_WIDTH) {
    return 'spectrum-grid-col-xs-6';
  }
  return '';
};

MarketplaceHomeController.prototype._preloadData = function() {
  var self = this;
  self.DataService.get('/preloaded_homepage_data').then(function(data) {
    self.browseByClassifications = data.browse_by_classifications;
    self.browseByLanguages = data.browse_by_languages;
    self.browseByTags = data.browse_by_tags;
  });

  this._webComponents_initSearchBar();
};

module.exports = MarketplaceHomeController;
